export const SERVICE_END_POINT = {

  assetUrl: "assets/json/",
  //brmsUrl: "../brms/",
  localBrms: "assets/json/brms/",

  // TO TEST IN QA9 (Should Not Be Pushed to QA7)
  brmsUrl: "../brms/direct/",

  configBrmsUrl: "../brms/configuration/",

  /* Service end points for FTE and higher environments */
  higherEnvironment: {
    envConfigUrl: '../envconfig/envconfigdcj.json',
    envHOConfigUrl: '../envconfigho/envconfigho.json',
    contentDataUrl: 'assets/json/contentData.json',
    startQuoteUrl: '/eap/request/dcj/quote/initiateQuote/',
    dcjConfiguration: 'assets/json/dcj-configuration.json',
    saveQuoteDataCapture: '/eap/request/dcj/quote/saveQuoteDataCapture/',
    getQuoteDataCapture: '/eap/request/dcj/quote/saveQuoteDataCapture/',
    calculateQuickQuote: '/eap/request/dcj/quote/calculateQuickQuote/',
    getQuote: '/eap/request/dcj/quote/getQuote/',
    getGuaranteedQuote: '/eap/request/dcj/quote/retrieveQuoteResult/',
    resumeApplication: '/eap/request/dcj/apply/resumeApplication/',
    getAllGuaranteedQuote: '/eap/request/dcj/quote/getYourQuotes/',
    deleteGuaranteedQuote: '/eap/request/dcj/quote/removeQuote/',
    dummyURL: 'assets/json/dummy.json',
    // getGuaranteedQuote: '/eap/request/dcj/quote/retrieveQuoteResult/',
    // getAllGuaranteedQuote: '/eap/request/dcj/quote/getYourQuotes/',
    // deleteGuaranteedQuote: '/eap/request/dcj/quote/removeQuote/',
    loginUser: '/eap/request/dcj/quote/loginUser/',
    deleteBenefitCard: '/eap/request/dcj/quote/deleteBenefitCard/',
    noAddressFound: './assets/json/no-address-found.json',
    resumeQuote: '/eap/request/dcj/quote/resumeQuote/',
    triggerUnderWriting: '/eap/request/dcj/quote/triggerUnderWriting/',
    reQuote: '/eap/request/dcj/quote/requoteRequest/',
    registrationDataCapture: '/eap/request/dcj/quote/registerUser/',
    getOtherTitleList: '/eap/request/dcj/quote/cvtService/personTitle',
    getWOMDetails: '/eap/request/dcj/quote/sendDCJQuoteDtlsToWOM/',
    getRiskWarnings: '/eap/request/dcj/quote/generateRiskWarningsEapDcj/',
    extendSessionUrl: '/eap/request/eapui/extendSession/',
    findAddressUrl: 'https://api.addressy.com/Capture/Interactive/Find/v1.20/json6.ws?Key',
    retrieveAddressUrl: 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.30/json6.ws?Key',
    logoutURL: '/eap/request/dcj/quote/logoutUser/',
    CMS_EPI_URL: 'https://test-epi.legalandgeneral.com/api/episerver/v2.0/content/',
    // CMS_GetYourOnlineQuote : 'assets/json/CMS_Data/Page_GetYourOnlineQuote.json',
    CMS_GetYourOnlineQuote: '../cms/Page_GetYourOnlineQuote.json',
    CMS_GuidanceAndAdvice: '../cms/Page_GuidanceAndAdvice.json',
    CMS_BeforeYouStart: '../cms/Page_BeforeYouStart.json',
    CMS_ToGetAQuoteYouWillNeed: '../cms/Page_ToGetAQuoteYouWillNeed.json',
    CMS_YOUR_LUMP_SUM_ALLOWANCES: '../cms/Page_YourLumpSumAllowance.json',
    CMS_YourPensionSavings: '../cms/Page_YourPensionSavings.json',
    CMS_YourPersonalDetails: '../cms/Page_YourPersonalDetails.json',
    CMS_HeaderAndFooter: '../cms/Page_HeaderAndFooter.json',
    CMS_PleaseConfirmYourDetails: '../cms/Page_PleaseConfirmYourDetails.json',
    CMS_YourProductOptions: '../cms/Page_YourProductOptions.json',
    CMS_Unsupported: '../cms/Page_Unsupported.json',
    CMS_ShortModal_BeforeTimeout: '../cms/ShortModal_BeforeTimeout.json',
    CMS_YourDependant: '../cms/Page_YourDependant.json',
    CMS_YourProductChoice: '../cms/Page_YourProductChoice.json',
    CMS_Lifestyle: '../cms/Page_Lifestyle.json',
    CMS_MedicalConditions: '../cms/Page_MedicalConditions.json',
    CMS_Registration: '../cms/Page_Registration.json',
    CMS_SessionClosed: '../cms/Page_SessionClosed.json',
    CMS_YourProductQuote: '../cms/Page_YourProductQuote.json',
    CMS_LoggedOut: '../cms/Page_LoggedOut.json',
    CMS_MedicalConditionBeforeYouStart: '../cms/Page_MedicalConditionBeforeYouStart.json',
    CMS_AddMedicalCondition: '../cms/Page_AddMedicalCondition.json',
    CMS_DoctorsDetailsQuote: '../cms/Page_DoctorsDetailsQuote.json',
    CMS_MedicalDetailsCapture: '../cms/Page_MedicalDetailsCapture.json',
    CMS_BeforeYouApply: '../cms/Page_BeforeYouApply.json',
    CMS_YourSavedQuotes: '../cms/Page_YourSavedQuotes.json',
    CMS_AgeValidation: '../cms/ShortModal_AgeValidation.json',
    CMS_Breadcrumbs: '../cms/Page_Breadcrumbs.json',
    CMS_AppSubmitted: '../cms/Page_AppSubmitted.json',
    CMS_YourPaymentDetails: '../cms/Page_YourPaymentDetails.json',
    CMS_YourPensionSavingsApply: '../cms/Page_YourPensionSavingsApply.json',
    CMS_UpdateMyDetails: '../cms/Page_UpdateMyDetails.json',
    CMS_YourPersonalDetailsApply: '../cms/Page_YourPersonalDetailsApply.json',
    CMS_ShortModal_RegistrationDiffers: '../cms/ShortModal_RegistrationDiffers.json',
    CMS_ShortModal_SavedNotLoggedIn: '../cms/ShortModal_SavedNotLoggedIn.json',
    CMS_RegistrationUnavailable: '../cms/Page_RegistrationUnavailable.json',
    CMS_ActivationLinkAcknowledgement: '../cms/Page_ActivationLinkAcknowledgement.json',
    CMS_ShortModal_CancelApp: '../cms/ShortModal_CancelApp.json',
    CMS_ShortModal_AppQuoteExp: '../cms/ShortModal_AppQuoteExp.json',
    CMS_YourDependantDetailsApply: '../cms/Page_YourDependantDetailsApply.json',
    CMS_DoctorsDetailsApply: '../cms/Page_DoctorsDetailsApply.json',
    CMS_DependantDoctorsDetailsApply: '../cms/Page_DependantDoctorsDetailsApply.json',
    CMS_ShortModal_SavedLoggedIn: '../cms/ShortModal_SavedLoggedIn.json',
    CMS_ShortModal_QuoteNotAvailableError: '../cms/ShortModal_QuoteNotAvailableError.json',
    CMS_ApplicationSummary: '../cms/Page_ApplicationSummary.json',
    CMS_YourBeneficaryDetailsApply: '../cms/Page_YourBeneficaryDetailsApply.json',
    CMS_YourProductApplication: '../cms/Page_YourProductApplication.json',
    CMS_ShortModal_NewQuote: '../cms/ShortModal_NewQuote.json',
    CMS_UserLoginRequired: '../cms/Page_UserLoginRequired.json',



    //BRMS json start
    // healthAndLifeStyleURL: "../brms/Lifestyle.json",
    // initialQuestionURL: "../brms/InitialQuestions.json",
    // medicationsDataJsonURL: "../brms/Medications.json",
    // rangeValidationURL: "../brms/Configuration.json",

    // Only TO TEST IN QA9 (Should Not Be Pushed to QA7)
    healthAndLifeStyleURL: "../brms/direct/Lifestyle.json",
    initialQuestionURL: "../brms/direct/InitialQuestions.json",
    medicationsDataJsonURL: "../brms/configuration/Medications.json",
    rangeValidationURL: "../brms/configuration/Configuration.json",

    ProductOptionsfromDealPartner: '/eap/request/dcj/quote/getProductOptions/',
    refreshCardUrl: '/eap/request/dcj/quote/refreshQuote/',
    quoteLockedUrl: '/eap/request/dcj/quote/isQuoteLocked/',
    analyticsScript: '//assets.adobedtm.com/launch-EN7d8cecf91fba48b9a3f8586523ef54e3.min.js',
    saveApplicationDataCapture: '/eap/request/dcj/apply/savePartialApplication/',
    getBanknameFromAuddis: '/eap/request/dcj/apply/verifyBankDetails/',
    createApplication: '/eap/request/dcj/apply/createApplication/',
    getCountryNames: '/eap/request/dcj/quote/cvtService/nonUKCountry',
    cancelApplication: '/eap/request/dcj/apply/cancelApplication/',
    testApi: '/eap/request/dcj/quote/triggerUnderwrtingHo/',
    submitApplication: '/eap/request/dcj/apply/submitApplication/',
    // CMS_ToGetAQuoteYouWillNeed : 'assets/json/CMS_Data/Page_ToGetAQuoteYouWillNeed.json',
    updateRegistrationDataCapture: '/eap/request/dcj/quote/saveCustomerDetails/',
    googleRecaptchaV2Url: '/eap/request/dcj/quote/googleCaptchaResponse/',
    getPesionProviderList: 'assets/json/pensionProviders.json',
    viewApplication: '/eap/request/dcj/apply/viewApplication',
    getEncryptedReference: '/eap/request/dcj/quote/frameReference/',
    sessionIdEncryption: '/eap/request/dcj/quote/sessionIdEncryption/',

    //UI Rules Json Start
    cedingFundUiRulesJsonUrl: '/eap/request/dcj/quote/fetchConfigUIData/',
    productChoiceUiRulesJsonUrl: '/eap/request/dcj/quote/fetchConfigUIData/',
    productOptionsUiRulesJsonUrl: '/eap/request/dcj/quote/fetchConfigUIData/',
    configData: './assets/json/configData.json'
  },

  /* Service end points for angular local development */
  localEnvironment: {
    envConfigUrl: 'assets/json/envconfigdcj.json',
    envHOConfigUrl: 'assets/json/envconfigho.json',
    contentDataUrl: 'assets/json/contentData.json',
    startQuoteUrl: 'assets/json/startQuote.json',
    dcjConfigurationUrl: 'assets/json/dcj-configuration.json',
    saveQuoteDataCapture: 'assets/json/productChoice.json',
    getQuoteDataCapture: '/assets/json/productChoice.json',
    calculateQuickQuote: '/assets/json/refreshCard.json',
    getQuote: '/assets/json/quoteResult.json',
    getGuaranteedQuote: '/assets/json/quoteResult.json',
    getAllGuaranteedQuote: '/assets/json/quaranteedquoteResult.json',
    dummyURL: 'assets/json/dummy.json',
    loginUser: '/assets/json/loginUser.json',
    deleteBenefitCard: '/assets/json/calculateQuickQuote.json',
    noAddressFound: './assets/json/no-address-found.json',
    resumeQuote: '/assets/json/PartialQuote.json',
    triggerUnderWriting: 'assets/json/productChoice.json',
    reQuote: '/assets/json/reQuote.json',
    getOtherTitleList: '/assets/json/otherTitleList.json',
    registrationDataCapture: '/assets/json/registerResponse.json',
    extendSessionUrl: '/assets/json/calculateQuickQuote.json',
    findAddressUrl: '/assets/json/findAddress.json',
    retrieveAddressUrl: '/assets/json/retrieveAddress.json',
    logoutURL: '/eap/request/dcj/quote/logoutUser/',
    CMS_EPI_URL: 'https://test-epi.legalandgeneral.com/api/episerver/v2.0/content/',
    CMS_GuidanceAndAdvice: '/assets/json/CMS_Data/Page_GuidanceAndAdvice.json',
    CMS_BeforeYouStart: '../cms/Page_BeforeYouStart.json',
    CMS_ToGetAQuoteYouWillNeed: '../cms/Page_ToGetAQuoteYouWillNeed.json',
    CMS_GetYourOnlineQuote: '../cms/Page_GetYourOnlineQuote.json',
    CMS_YOUR_LUMP_SUM_ALLOWANCES: '../cms/Page_YourLumpSumAllowance.json',
    CMS_YourPensionSavings: '../cms/Page_YourPensionSavings.json',
    CMS_YourPersonalDetails: '../cms/Page_YourPersonalDetails.json',
    CMS_HeaderAndFooter: '../cms/Page_HeaderAndFooter.json',
    CMS_PleaseConfirmYourDetails: '../cms/Page_PleaseConfirmYourDetails.json',
    CMS_YourProductOptions: '../cms/Page_Page_YourProductOptions.json',
    CMS_Unsupported: '../cms/Page_Unsupported.json',
    CMS_ShortModal_BeforeTimeout: '../cms/ShortModal_BeforeTimeout.json',
    CMS_YourDependant: '../cms/Page_YourDependant.json',
    CMS_YourProductChoice: '../cms/Page_YourProductChoice.json',
    CMS_Lifestyle: '../cms/Page_Lifestyle.json',
    CMS_MedicalConditions: '../cms/Page_MedicalConditions.json',
    CMS_Registration: '../cms/Page_Registration.json',
    CMS_SessionClosed: '../cms/Page_SessionClosed.json',
    CMS_YourProductQuote: '../cms/Page_YourProductQuote.json',
    CMS_LoggedOut: '../cms/Page_LoggedOut.json',
    CMS_MedicalConditionBeforeYouStart: '../cms/Page_MedicalConditionBeforeYouStart.json',
    CMS_AddMedicalCondition: '../cms/Page_AddMedicalCondition.json',
    CMS_DoctorsDetailsQuote: '../cms/Page_DoctorsDetailsQuote.json',
    CMS_MedicalDetailsCapture: '../cms/Page_MedicalDetailsCapture.json',
    CMS_BeforeYouApply: '../cms/Page_BeforeYouApply.json',
    CMS_YourSavedQuotes: '../cms/Page_YourSavedQuotes.json',
    CMS_AgeValidation: '../cms/ShortModal_AgeValidation.json',
    CMS_Breadcrumbs: '../cms/Page_Breadcrumbs.json',
    CMS_AppSubmitted: '../cms/Page_AppSubmitted.json',
    CMS_YourPaymentDetails: '../cms/Page_YourPaymentDetails.json',
    CMS_YourPensionSavingsApply: 'assets/json/CMS_Data/Page_YourPensionSavingsApply.json',
    CMS_UpdateMyDetails: '../cms/Page_UpdateMyDetails.json',
    CMS_YourPersonalDetailsApply: '../cms/Page_YourPersonalDetailsApply.json',
    CMS_ShortModal_RegistrationDiffers: '../cms/ShortModal_RegistrationDiffers.json',
    CMS_ShortModal_SavedNotLoggedIn: '../cms/ShortModal_SavedNotLoggedIn.json',
    CMS_RegistrationUnavailable: '../cms/Page_RegistrationUnavailable.json',
    CMS_ActivationLinkAcknowledgement: '../cms/Page_ActivationLinkAcknowledgement.json',
    CMS_ShortModal_CancelApp: '../cms/ShortModal_CancelApp.json',
    CMS_ShortModal_AppQuoteExp: '../cms/ShortModal_AppQuoteExp.json',
    CMS_YourDependantDetailsApply: '../cms/Page_YourDependantDetailsApply.json',
    CMS_DoctorsDetailsApply: '../cms/Page_DoctorsDetailsApply.json',
    CMS_DependantDoctorsDetailsApply: '../cms/Page_DependantDoctorsDetailsApply.json',
    CMS_ShortModal_SavedLoggedIn: '../cms/ShortModal_SavedLoggedIn.json',
    CMS_ShortModal_QuoteNotAvailableError: '../cms/ShortModal_QuoteNotAvailableError.json',
    CMS_ApplicationSummary: 'assets/json/CMS_Data/Page_ApplicationSummary.json',
    CMS_YourBeneficaryDetailsApply: 'assets/json/CMS_Data/Page_YourBeneficaryDetailsApply.json',
    CMS_YourProductApplication: 'assets/json/CMS_Data/Page_YourProductApplication.json',
    CMS_ShortModal_NewQuote: 'assets/json/CMS_Data/ShortModal_NewQuote.json',
    CMS_UserLoginRequired: 'assets/json/CMS_Data/Page_UserLoginRequired.json',
    //BRMS json start
    healthAndLifeStyleURL: '/assets/json/brms/Lifestyle.json',
    initialQuestionURL: '/assets/json/brms/InitialQuestions.json',
    medicationsDataJsonURL: '/assets/json/brms/Medications.json',
    rangeValidationURL: '/assets/json/brms/Configuration.json',
    //BRMS json end

    ProductOptionsfromDealPartner: '/assets/json/productOptionsFromDealPartner.json',
    refreshCardUrl: '/assets/json/cardRefresh.json',
    quoteLockedUrl: '/assets/json/isQuoteLocked.json',
    analyticsScript: '//assets.adobedtm.com/4ca192c828d8/88de2c3e692b/launch-08b2d79adebb-development.min.js',
    saveApplicationDataCapture: '/assets/json/applicationData.json',
    getBanknameFromAuddis: '/assets/json/bankName.json',
    createApplication: '/assets/json/applicationData.json',
    getCountryNames: '/assets/json/countryList.json',
    cancelApplication: '/assets/json/quaranteedquoteResult.json/',
    resumeApplication: '/assets/json/applicationData.json/',
    testApi: '/eap/request/dcj/quote/triggerUnderwrtingHo/',
    submitApplication: '/assets/json/applicationData.json/',
    updateRegistrationDataCapture: '/assets/json/registerResponse.json',
    googleRecaptchaV2Url: '/assets/json/google_reCaptcha_response.json',
    getPesionProviderList: 'assets/json/pensionProviders.json',
    viewApplication: '/assets/json/viewApplication.json',
    getEncryptedReference: '/assets/json/frameReference.json',
    sessionIdEncryption: '/assets/json/sessionIdEncryption/',

    //UI Rules Json Start
    cedingFundUiRulesJsonUrl: '/assets/json/cedingPensionRefData.json',
    productChoiceUiRulesJsonUrl: '/assets/json/productChoiceRefData.json',
    productOptionsUiRulesJsonUrl: '/assets/json/productOptionsRefData.json/',
    configData: './assets/json/configData.json'
  }


};
